/**
 * Hashes a string using SHA-256 for secure storage of security question answers.
 * Implements Ohio OAC 4501-7 requirement for secure identity verification data.
 * 
 * @param answer The raw answer string to hash
 * @returns A SHA-256 hex encoded string
 */
export const hashAnswer = async (answer: string): Promise<string> => {
    const encoder = new TextEncoder();
    const data = encoder.encode(answer.toLowerCase().trim());
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);

    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');

    return hashHex;
};

/**
 * Compares a raw answer string against a stored SHA-256 hash.
 * 
 * @param answer The raw answer string to compare
 * @param hash The stored hash to compare against
 * @returns True if the hashed answer matches the provided hash
 */
export const compareAnswerHash = async (answer: string, hash: string): Promise<boolean> => {
    const answerHash = await hashAnswer(answer);
    return answerHash === hash;
};
